/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoice_Request_Tax_IdInputs */

const en_invoice_request_tax_id = /** @type {(inputs: Invoice_Request_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tax ID`)
};

const pl_invoice_request_tax_id = /** @type {(inputs: Invoice_Request_Tax_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`NIP`)
};

/**
* | output |
* | --- |
* | "Tax ID" |
*
* @param {Invoice_Request_Tax_IdInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const invoice_request_tax_id = /** @type {((inputs?: Invoice_Request_Tax_IdInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoice_Request_Tax_IdInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_invoice_request_tax_id(inputs)
	return en_invoice_request_tax_id(inputs)
});